import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCapture: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCapture"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V9H5V5H9V3H3ZM15 3V5H19V9H21V3H15ZM3 15H5V19H9V21H3V15ZM21 15H19V19H15V21H21V15ZM9.58579 8L10.5858 7H13.4142L14.4142 8H17V16H7V8H9.58579ZM12 10.35C11.1716 10.35 10.5 11.0216 10.5 11.85C10.5 12.6784 11.1716 13.35 12 13.35C12.8284 13.35 13.5 12.6784 13.5 11.85C13.5 11.0216 12.8284 10.35 12 10.35Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCapture;
